<div class="topDiv" style="margin-top:4%" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv">

        <div>

            <div class="row topRowMargins headerStyle">

                <div class="col-lg-12">

                    Screen Creator

                </div>

            </div>

        </div>

        <div class="row topRowMargins" style="margin-left:1%">

            <div class="col-lg">

                <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" i18n="@@spmsloginbutton" type="button" (click)="deleteTransactionTable()" [style.background-color]="backgroundColorButton"
                 style="padding: 0.3rem 1.6rem;font-size: 0.85rem;">Delete Screen</button>

            </div>

            <div class="col-lg">

            </div>

            <div class="col-lg">

            </div>

        </div>

        <div class="row topRowMargins" style="margin-left:1%">

            <div class="col-lg">

                <input type="radio" [checked]="true" name="nameScreenCreator" class="radioCss" (change)="selectScreenCreator('MasterScreenCreator')">

                <span style="margin-left:1%">

                    Master Screen Creator

                </span>

            </div>

        </div>

        <div class="row topRowMargins" style="margin-left:1%">

            <div class="col-lg">

                <input type="radio" [checked]="false" name="nameScreenCreator" class="radioCss" (change)="selectScreenCreator('TransactionScreenCreator')">

                <span style="margin-left:1%">

                    Transaction Screen Creator

                </span>

            </div>

        </div>

        <div>

            <form novalidate [formGroup]="formValid">

                <div class="row topRowMargins" style="margin-left:1%">

                    <div class="col-lg-3">

                        <mat-form-field appearance="outline">

                            <mat-label i18n="@@spmsUserReglastname">Screen Name</mat-label>

                            <input matInput type="text" formControlName="screenName"
                                [(ngModel)]="screenCreatorFields.screenName" required maxlength="60" (ngModelChange)="screenNameIsChanged()">

                            <mat-error *ngFor="let validation of validation_messages.screenName">

                                <span
                                    *ngIf="formValid.get('screenName').hasError(validation.type) && (formValid.get('screenName').dirty || formValid.get('screenName').touched)">

                                    {{ validation.message }}

                                </span>

                            </mat-error>

                        </mat-form-field>

                    </div>

                    <div class="col-lg-3">

                        <mat-form-field appearance="outline">

                            <mat-label i18n="@@spmsUserReglastname">Display Name</mat-label>

                            <input matInput type="text" formControlName="displayName"
                                [(ngModel)]="screenCreatorFields.displayName" required>

                            <mat-error *ngFor="let validation of validation_messages.displayName">

                                <span
                                    *ngIf="formValid.get('displayName').hasError(validation.type) && (formValid.get('displayName').dirty || formValid.get('displayName').touched)">

                                    {{ validation.message }}

                                </span>

                            </mat-error>

                        </mat-form-field>

                    </div>

                    <div class="col-lg-3">

                        <mat-form-field appearance="outline">

                            <mat-label i18n="@@spmsUserReglastname">Number Of Columns In Row</mat-label>

                            <mat-select formControlName="numberOfColumnsInRow"
                                [(ngModel)]="screenCreatorFields.numberOfColumnsInRow" required>

                                <mat-option *ngFor="let numberOfColumnsInRowDataTemp of numberOfColumnsInRowData"
                                    [(value)]="numberOfColumnsInRowDataTemp.value">

                                    {{numberOfColumnsInRowDataTemp.name}}

                                </mat-option>

                            </mat-select>

                            <mat-error *ngFor="let validation of validation_messages.numberOfColumnsInRow">

                                <span
                                    *ngIf="formValid.get('numberOfColumnsInRow').hasError(validation.type) && (formValid.get('numberOfColumnsInRow').dirty || formValid.get('numberOfColumnsInRow').touched)">

                                    {{ validation.message }}

                                </span>

                            </mat-error>

                        </mat-form-field>

                    </div>

                </div>

                <div class="row topRowMargins" style="margin-left:1%"><!--Second row started.-->

                    <div class="col-lg-1">

                        MultiTenant

                    </div>

                    <div class="col-lg-1">

                        <input type="radio" [checked]="true" name="checkingMultiTenant" class="radioCss" (change)="selectMultiTenant(true)">

                        <span style="margin-left:1%">

                            Yes

                        </span>

                    </div>

                    <div class="col-lg-1">

                        <input type="radio" [checked]="false" name="checkingMultiTenant" class="radioCss" (change)="selectMultiTenant(false)">

                        <span style="margin-left:1%">

                            No

                        </span>

                    </div>

                    <div class="col-lg-3"><!--Image name field with attachment icon.-->

                        <div style="display:flex">

                            <mat-form-field appearance="outline">

                                <mat-label i18n="@@TMSTAFFMASTERPassportPhoto">Screen Image</mat-label>

                                <input matInput class="file-path validate" type="text" maxlength="500"
                                    formControlName="screenImageName" id="screenImageName"
                                    [(ngModel)]="screenCreatorFields.screenImageName" readonly>


                                <mat-error *ngFor="let validation of validation_messages.screenImageName">

                                    <span
                                        *ngIf="formValid.get('screenImageName').hasError(validation.type) && (formValid.get('screenImageName').dirty || formValid.get('screenImageName').touched)">

                                        {{ validation.message }}

                                    </span>

                                </mat-error>

                            </mat-form-field>

                            <div class="file-field" style="width: 20%;">
                                <a class="btn-floating  btn-sm m-0  float-right">
                                    <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                                    <input type="file" id="screenImage" name="screenImage"
                                    (change)="screenImageFunction($event)" formControlName="screenImage">
                                </a>
                            </div>
                        </div>

                    </div><!--Image Name field with attachment icon.-->

                    <div class="col-lg-3"><!--Start image show.-->

                        <div *ngIf="screenImageShow" style="width:100%;height:75px;display: inline-block;">
                        <div class="card" style="width:75%; display: inline-block;margin:0% 1%;height: 100%;">
                        <div class="cardButtonDiv">
                            <button type="button" class="close badge badge-danger" aria-label="Close"
                            (click)="deleteScreenImage()"><em class="fas fa-times" aria-hidden="true"></em>
                            </button>
                        </div>
                        <!-- Card content -->
                        <div class="card-body" style="padding: 2%;overflow: hidden;height: -webkit-fill-available;"
                            (click)="openScreenImage('screenImage')">

                            <!-- Card image -->
                            <div class="view overlay">
                            <img class="card-img-top" [src]="getSanitizer(screenImage)" alt="Card image cap"
                                style="width: 100%;height: 70px;">
                            <a>
                                <div class="mask rgba-white-slight"></div>
                            </a>
                            </div>

                        </div>
                        <mat-label style="font-size: x-small ;" i18n="@@TMSTAFFMASTERPassportPhotoname">Screen Image
                        </mat-label>
                        </div>
                        </div>

                    </div><!--End image name.-->

                </div><!--Second row ended.-->

            </form>

            <div class="row topRowMargins" *ngIf="showMenuOrder" style="margin-left:1%">

                <div class="col-sm-12 col-lg-3">

                    Menu Order

                </div>

                <div class="col-lg-9" style="display: flex;">

                    <div class="col-sm-12 col-lg-3" style=" margin-right: -80px;padding: 4px;">

                        <Label style="padding-right: 10px;">Parent Level :- </Label>

                    </div>

                    <div class="col-sm-12 col-lg-3" style="border: 1px solid darkgray;height: 37px;padding: 6px 0px 0px 6px;border-radius: 4px;margin-right: -60px;">

                        {{screenNameData}}

                    </div>

                    <div class=" col-sm-12 col-lg-3">

                        <div>

                            <button  style="width: 100%;padding-left: 54px;background: border-box;font-size: initial;font-weight: 300;border: none;color: darkslategrey;" (click)="screenNameSelect('Parent itself')">

                                Parent itself

                            </button>

                        </div>

                        <mat-tree
                                    [dataSource]="nestedDataSource"
                            [treeControl]="nestedTreeControl"
                            class="example-tree menu-tree">

                            <mat-tree-node *matTreeNodeDef="let node" class="menu-tree-node">
                                <button type="button" class="tree-menu-button" (click)="screenNameSelect(node.screenName)">
                                <span class="tree-node-text">{{ node.screenName }}</span>
                                </button>
                            </mat-tree-node>

                            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
                                <div class="menu-tree-node">
                                    <button
                                        type="button"
                                        class="tree-menu-button"
                                        matTreeNodeToggle
                                        (click)="screenNameSelect(node.screenName)">

                                        <mat-icon class="tree-arrow">
                                        {{ nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                        </mat-icon>

                                        <span class="tree-node-text">{{ node.screenName }}</span>
                                    </button>
                                    </div>

                                    <ul class="tree-child-list" [class.example-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                    </ul>
                                </mat-nested-tree-node>

                    </mat-tree>

                    </div>

                </div>

            </div>

        </div>

        <div class="row topRowMargins headersCSS" style="margin-left:2%">

            Master Table

        </div>

        <div class="row topRowMargins dataCSS" style="margin-left:2%">

            <div>Master Table Name : {{masterTableName}}</div>

        </div>

        <div class="row topRowMargins dataCSS" style="margin-left:2%">

            <div>Master Table ID : {{masterTableID}}</div>

        </div>

        <div *ngIf='selectedScreenCreator=="TransactionScreenCreator"'>

            <div class="row topRowMargins headersCSS" style="margin-left:2%">

                Transaction Table

            </div>

            <div class="row topRowMargins dataCSS" style="margin-left:2%">

                <div>Transaction Table Name : {{transactionTableName}}</div>

            </div>

            <div class="row topRowMargins dataCSS" style="margin-left:2%">

                <div>Transaction Table ID : {{transactionTableID}}</div>

            </div>

        </div>

        <div class="row mb-4" style="margin-top:1%">

            <div class="col-lg text-center">

                <button i18n="@@spmsloginbutton" type="button" (click)="addFieldsToMasterTable()" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem">Add Fields to Master Table</button>

                <span *ngIf='selectedScreenCreator=="TransactionScreenCreator"'>

                    <button i18n="@@spmsloginbutton" type="button" (click)="addFieldsToTransactionTable()" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"  [style.background-color]="backgroundColorButton" style="padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem">Add Fields to Transaction Table</button>

                </span>

                <button i18n="@@spmsloginbutton" type="button" (click)="create()" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem">Publish</button>

            </div>

        </div>

        <div class="container"
            style="padding:20px;border:dotted 1px;white-space:nowrap;overflow-x:auto;margin-top:2%;max-width:inherit;margin-bottom:2%">

            <div class="text-center">Master Table Fields</div>

            <div style="font-size:14px;margin-top:2%">

                <div *ngFor="let totalObjectTemp of totalObjectOfMasterTable; let i = index">

                    <div style="margin-top:1%">

                        <div style="display:inline-block;margin-left:10px;margin-right:10px">

                            <span class="addSpan" style="color:black;font-size:18px">

                                <em class="fas fa-minus-circle" title="Remove Field"
                                    (click)="removeFieldFromMasterTable(totalObjectTemp,i)"></em>

                            </span>

                        </div>

                        <div *ngFor="let key of object.keys(totalObjectTemp)" style="display:inline">

                            <div class="inputFieldsCss" style="overflow:hidden" *ngIf="displayNamesOfMasterTable[i][key]!=undefined">

                                <div>

                                    <span style="font-weight:500">{{displayNamesOfMasterTable[i][key]}}</span>

                                    <span style="margin-left:5px;font-weight:500">:</span>

                                    <br>

                                    <span>{{totalObjectTemp[key]}}</span>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div *ngIf='selectedScreenCreator=="TransactionScreenCreator"'>

            <div class="container"
                style="padding:20px;border:dotted 1px;white-space:nowrap;overflow-x:auto;max-width:inherit;margin-bottom:2%">

                <div class="text-center">Transaction Table Fields</div>

                <div style="font-size:14px;margin-top:2%">

                    <div *ngFor="let totalObjectTemp of totalObjectOfTransactionTable; let i = index">

                        <div style="margin-top:1%">

                            <div style="display:inline-block;margin-left:10px;margin-right:10px">

                                <span class="addSpan" style="color:black;font-size:18px">

                                    <em class="fas fa-minus-circle" title="Remove Field"
                                        (click)="removeFieldFromTransactionTable(totalObjectTemp,i)"></em>

                                </span>

                            </div>

                            <div *ngFor="let key of object.keys(totalObjectTemp)" style="display:inline">

                                <div class="inputFieldsCss" style="overflow:hidden" *ngIf="displayNamesOfTransactionTable[i][key]!=undefined">

                                    <div>

                                        <span style="font-weight:500">{{displayNamesOfTransactionTable[i][key]}}</span>

                                        <span style="margin-left:5px;font-weight:500">:</span>

                                        <br>

                                        <span>{{totalObjectTemp[key]}}</span>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>


        <div>
            <mat-toolbar class="agGridtoperDiv card" 
            style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;"
            >
<!-- class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem" -->

                <span class="example-spacer"></span>

                <!-- <span style="color:black;font-size:16px" [style.background-color]="backgroundColorButton" title="Download" (click)="onBtExport()">Download</span>

                <em class="fas fa-download example-icon" title="Download" (click)="onBtExport()" style="color:black;font-size:18px"></em> -->

                <button  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding-left:1.2rem;padding-right: 1.2rem;padding-top:0.4rem;padding-bottom:0.4rem"  [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                          <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                  </button> 

                <div class="insertPageNoDiv">

                    <mat-form-field appearance="outline">

                    <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>

                    <input matInput type="text" (input)="onSearchChange($event.target.value)">

                </mat-form-field>

                </div>

                <div class="selectRecordsDiv" style="width:9.5%">

                    <mat-form-field appearance="outline" style="width:100%">

                        <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>

                        <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged(value)">

                            <mat-option value="10" selected>10</mat-option>

                            <mat-option value="200">200</mat-option>

                            <mat-option value="300">300</mat-option>

                            <mat-option value="400">400</mat-option>

                        </mat-select>

                    </mat-form-field>

                </div>

                <div class="card pagination paginationFirstButton paginationFirstlastButton">

                    <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>

                </div>

                <div class="card pagination paginationButtons btn-rounded">

                    <ul>

                        <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                            (click)="onBtPrevious()"></em></li>

                         <li>{{currentpage}}/{{totalpages}}</li>

                        <li class="paginationliicon" style="padding:0;"><em
                            class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>

                    </ul>

                </div>

                <div class="card pagination paginationLastButton paginationFirstlastButton">

                    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>

                </div>

            </mat-toolbar>

        </div>


        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scrollbar-dusty-grass square thin"
        [columnDefs]="columnDefs"  [animateRows]="true"
        [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
        [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
        (paginationChanged)="onPaginationChanged()" [components]="components"
        (gridReady)="onGridReady($event)" [hidden]="!true" (cellDoubleClicked)="retrieveTransactionData($event)">
        </ag-grid-angular>

        <!-- <div  style="margin-bottom:4vh">

            <mat-toolbar class="agGridfooterDivtoolbar">

                <span class="example-spacer"></span>

                <span style="color:black;font-size:16px" title="Download" (click)="onBtExport()">Download</span>

                <em class="fas fa-download example-icon" title="Download" (click)="onBtExport()" style="color:black;font-size:18px"></em>

                <div class="insertPageNoDiv">

                    <mat-form-field appearance="outline">

                    <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>

                    <input matInput type="text" (input)="onSearchChange($event.target.value)">

                </mat-form-field>

                </div>

                <div class="selectRecordsDiv" style="width:9.5%">

                    <mat-form-field appearance="outline" style="width:100%">

                        <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>

                        <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged(value)">

                            <mat-option value="10" selected>10</mat-option>

                            <mat-option value="200">200</mat-option>

                            <mat-option value="300">300</mat-option>

                            <mat-option value="400">400</mat-option>

                        </mat-select>

                    </mat-form-field>

                </div>

                <div class="card pagination paginationFirstButton paginationFirstlastButton">

                    <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>

                </div>

                <div class="card pagination paginationButtons btn-rounded">

                    <ul>

                        <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                            (click)="onBtPrevious()"></em></li>

                         <li>{{currentpage}}/{{totalpages}}</li>

                        <li class="paginationliicon" style="padding:0;"><em
                            class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>

                    </ul>

                </div>

                <div class="card pagination paginationLastButton paginationFirstlastButton">

                    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>

                </div>

            </mat-toolbar>

        </div> -->

    </div>

</div>
